var _path, _path2, _path3, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoticeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 62,
    viewBox: "0 0 63 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.5271 62H12.4642C7.17153 62 2.84277 57.6837 2.84277 52.4063V12.4762C2.84277 7.19882 7.17153 2.88252 12.4642 2.88252H52.5096C57.8022 2.88252 62.131 7.19882 62.131 12.4762V52.4063C62.1485 57.6837 57.8197 62 52.5271 62Z",
    fill: "#FFF5DB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6668 59.1349H9.62141C4.32876 59.1349 0 54.8187 0 49.5412V9.5937C0 4.31629 4.32876 0 9.62141 0H49.6668C54.9595 0 59.2882 4.31629 59.2882 9.5937V49.5238C59.3058 54.8187 54.977 59.1349 49.6668 59.1349Z",
    fill: "#FFC83E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6276 19.0567C31.6276 18.0838 30.8389 17.2951 29.866 17.2951C28.8932 17.2951 28.1045 18.0838 28.1045 19.0567V33.6523C28.1045 34.6252 28.8932 35.4138 29.866 35.4138C30.8389 35.4138 31.6276 34.6252 31.6276 33.6523V19.0567Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 28.1045,
    y: 39.1382,
    width: 3.52308,
    height: 3.52308,
    rx: 1.76154,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoticeIcon);
export default __webpack_public_path__ + "static/media/noticeIcon.56b4f17101c820eb722301a92bbbb9c1.svg";
export { ForwardRef as ReactComponent };